import styled from 'styled-components/macro';

import { baseSpacing, colors } from 'css/constants';
import mq from 'css/mediaQueries';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  border: 1px solid rgb(0 0 0 / 20%);
  margin-bottom: ${baseSpacing / 2}px;
  background-color: #fff;

  ${mq.desk} {
    margin-bottom: ${baseSpacing / 4}px;
  }
`;

export const Last4Wrapper = styled.div`
  display: flex;
  flex-wrap: no-wrap;

  & > span {
    display: flex;
    align-items: center;
    font-size: 0.5em;
  }
`;

export const Body = styled.div`
  padding: ${baseSpacing / 3}px;
  background-color: ${colors.lightGrey};
  text-shadow: none;

  ${mq.desk} {
    display: none;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;

    li {
      position: relative;
      display: flex;
      justify-content: space-between;

      span {
        position: relative;
        padding: 0 6px;
        z-index: 1;
        background: ${colors.lightGrey};
      }

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 0;
        border-bottom: 1px dashed rgb(0 0 0 / 10%);
        top: calc(50% - 1px);
        transform: translateY(1px);
      }
    }
  }
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 50px auto 35px;
  grid-column-gap: ${baseSpacing / 2}px;
  align-items: center;
  width: 100%;
  padding: ${baseSpacing / 3}px;
  border-left: ${baseSpacing / 6}px solid rgb(0 0 0 / 33%);

  & > * {
    white-space: nowrap;
  }

  ${mq.desk} {
    grid-template-columns: 50px 1.5fr 1fr 5fr 35px;
  }
`;

export const ConditionallyHidden = styled.div`
  ${mq.portable} {
    display: none;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  margin-right: 0;
  margin-left: auto;
  padding: ${baseSpacing / 4}px;
  background: transparent;
  border-color: transparent;
  font-size: 0.8rem;
  color: ${colors.red};
  opacity: 0.8;

  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
    border: 1px solid rgb(0 0 0 / 8%);
    box-shadow: 1px 1px 1px rgb(0 0 0 / 6%);
  }
`;
